import React from 'react'
import { Link } from "react-router-dom"

const About = () => {
	return (
		<div className='about-section'>
			<div className="container-main">
				<div className="row align-items-center">
					<div className="col-lg-6">
						<h1 className='about-heading montserrat'>Shaping the Future, <span className='about-block-text montserrat'>One Girl at a Time</span></h1>
						<p className='about-sub-text'>Éloria International Girls School is more than just an institution — it is a fertile ground for the overall growth of the next generation, with souls engraved in spiritual values and skills chiselled to meet the unseen future of science and technology.</p>
						<Link className="btn enquire-btn-about" to='/about'>About us</Link>
					</div>
					<div className="col-lg-6">
						<div className="about-grid">
							<div className="about-grid-card">
								<div className="about-grid-icon">
									<i className="ri-book-open-line"></i>
								</div>
								<h4 className="about-grid-title">Recitation Science</h4>
								<p className="about-grid-text">Mastering the art and science of Quranic recitation with proper rules and precision.</p>
							</div>
							<div className="about-grid-card">
								<div className="about-grid-icon">
									<i className="ri-brain-line"></i>
								</div>
								<h4 className="about-grid-title">Memorisation</h4>
								<p className="about-grid-text">Psychologically informed pedagogy that strengthens memory and cultivates analytical depth.</p>
							</div>
							<div className="about-grid-card">
								<div className="about-grid-icon">
									<i className="ri-quill-pen-line"></i>
								</div>
								<h4 className="about-grid-title">Tajweed</h4>
								<p className="about-grid-text">Perfecting pronunciation and intonation through structured Tajweed methodology.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default About
